import React from 'react';
import _ from "lodash";
import { Row, Col, Label } from "reactstrap";
import FormInput from '../../../../comum/components/FormInput';
import FormInputNumber from '../../../../comum/components/FormInputNumber';
import FormInputLacre from '../../../../comum/components/FormInputLacre';
import FormSelect from '../../../../comum/components/FormSelectPesquisa';
import FormSelect2 from '../../../../comum/components/FormSelect';

import { inject, observer } from "mobx-react";
import { isInvalidoTam5 } from '../../../../../utils/validadores';
import { IconeDelete } from '../../../../comum/components/Icones';
import CardContainerFilhoStore from "../stores/CardContainerFilhoStore";
import CheckboxField from '../../../../comum/components/CheckboxField';
import { valida } from "../../../../principal/containers/Valida"
import { terminal as TERMINAL } from '../../../../../config/Constantes';

@inject("store")
@observer
export default class CardContainerFilho extends React.Component {
    constructor(props) {
        super(props);
        // if(this.props.agendamento.isEditar ? PreviaImportacaoDepot :)  _.set(this.props, `isEscondido`, false);
        this.appStore = this.props.store.appStore;
        this.parametrosStore = this.props.store.parametrosStore;

        this.controller = new CardContainerFilhoStore(this.props.tipoAgenda);
        this.bookingController = this.props.controller;
        // this.handleOnChange = this.handleOnChange.bind(this);
        this.sobremedidaBloqueado = true;

        this.state = {
            atualizado: true,
            lacresMarcados: [],
            iso: null,
            capacidademax: null,
            armador: null,
            armadorDescricao: null,
            tara: null,
            cliente: null,
            categoria: null,
            tipoMercadoria: null
        };
        if (this.props.agendamento.isEditar) this.getDadosClientEdicao()
        if (!this.props.agendamento.isEditar) this.getDadosClientAposDelete(this.props.container.importador)
    };

    componentDidMount() {
        this.controller.carregarArmadores();
        if (this.props.agendamento.isEditar) this.props.agendamento.carregarTransportadoras()
    };

    getDadosClientEdicao = async () => {
        //{value: 7158, label: 'NASA / '}label: "NASA / "value: 7158[[Prototype]]: Object importador importador NASA / 
        await this.controller.carregarClientesPorId(this.props.container.Id);
        if (this.controller.clientes.length > 0)
        {
            var item = {
                    value: this.controller.clientes[0].CampoValue,
                    label: this.controller.clientes[0].CampoDescricao
            }
            this.CarregaImportadorEdicao(item, 'importador', 'importador', item.label);
        }
    }

    CarregaImportadorEdicao = (event, campo, campoState, valor) => {
        this.props.setDado(`${this.props.dado}.${campo}`, event);

        this.setState({
            [campoState]: (event != null ? valor : null)
        });


        if(campo == 'importador'){
           if(this.props.agendamento.tipoCadastroImportacaoEntrada == "One")
           {
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `CodCntr`, this.props.container.CodCntr);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `armador`, this.props.container.armador);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `importador`, this.props.container.importador);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `PreviaImportacaoDepot`, this.props.container.PreviaImportacaoDepot);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `ArmId`, this.props.container.ArmId);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `CodIso`, this.props.container.CodIso);
           }else
           {
            let dados = { 
                CodCntr: this.props.container.CodCntr,
                armador: this.props.container.armador,
                importador: this.props.container.importador,
                PreviaImportacaoDepot: this.props.container.PreviaImportacaoDepot,
                ArmId: this.props.container.ArmId,
                CodIso:  this.props.container.CodIso
           }
               _.set(this.props.agendamento.dadosAgendamento, `Containeres[${this.props.index}]`, dados);
        }

        console.log('index', this.props.index, this.props.agendamento.dadosAgendamento.Containeres[this.props.index], this.props.agendamento.dadosAgendamento.Containeres)
        // _.set(this.props.agendamento, `dadosAgendamento`, dados)
        }
    }


    getDadosClientAposDelete = async (dado) => {
        console.log('getDadosClientAposDelete', dado)
        if (dado != null) { 
             //{value: 7158, label: 'NASA / '}label: "NASA / "value: 7158[[Prototype]]: Object importador importador NASA / 
            await this.controller.carregarClientesPorIdImportador(dado);
            if (this.controller.clientes.length > 0)
            {
                var item = {
                        value: this.controller.clientes[0].CampoValue,
                        label: this.controller.clientes[0].CampoDescricao
                }
                this.CarregaImportadorAposDelete(item, 'importador', 'importador', item.label);
            }
        }
    }

    CarregaImportadorAposDelete = (event, campo, campoState, valor) => {
        this.props.setDado(`${this.props.dado}.${campo}`, event);

        this.setState({
            [campoState]: (event != null ? valor : null)
        });


        if(campo == 'importador'){
           if(this.props.agendamento.tipoCadastroImportacaoEntrada == "One")
           {
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `CodCntr`, this.props.container.CodCntr);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `armador`, this.props.container.armador);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `importador`, this.props.container.importador);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `PreviaImportacaoDepot`, this.props.container.PreviaImportacaoDepot);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `ArmId`, this.props.container.ArmId);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `CodIso`, this.props.container.CodIso);
           }else
           {
            let dados = { 
                CodCntr: this.props.container.CodCntr,
                armador: this.props.container.armador,
                importador: this.props.container.importador,
                PreviaImportacaoDepot: this.props.container.PreviaImportacaoDepot,
                ArmId: this.props.container.ArmId,
                CodIso:  this.props.container.CodIso
           }
               _.set(this.props.agendamento.dadosAgendamento, `Containeres[${this.props.index}]`, dados);
        }

        console.log('index', this.props.index, this.props.agendamento.dadosAgendamento.Containeres[this.props.index], this.props.agendamento.dadosAgendamento.Containeres)
        // _.set(this.props.agendamento, `dadosAgendamento`, dados)
        }
    }





    refresh = () => {
        this.setState({ atualizado: false });
        setTimeout(function () {
            this.setState({ atualizado: true })
        }.bind(this), 1);
    };

    AtualizaEdicao = () => {
        if (this.props.agendamento.isEditar) {
            _.set(this.props.container, `isEscondido`, false);
        }
    };

    handleCarregarRespOva = (cnpj, salvarDados = true) => {
        console.log(cnpj)
    };

 
    buscaImportador = (event) => {
        const trimmedEvent = event.trim(); // Remove espaços em branco no início e no fim
    
        if (trimmedEvent.length >= 3) {
            this.controller.carregarClientes(trimmedEvent);
        }
    }

    handleCampoChange = (event, campo, campoState, valor) => {
        this.props.setDado(`${this.props.dado}.${campo}`, event);

        this.setState({
            [campoState]: (event != null ? valor : null)
        });


        if (campo == 'importador') {
           if(this.props.agendamento.tipoCadastroImportacaoEntrada == "One")
           {
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `CodCntr`, this.props.container.CodCntr);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `armador`, this.props.container.armador);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `importador`, this.props.container.importador);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `PreviaImportacaoDepot`, this.props.container.PreviaImportacaoDepot);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `ArmId`, this.props.container.ArmId);
                _.set(this.props.agendamento.dadosAgendamento.Containeres[this.props.index], `CodIso`, this.props.container.CodIso);


           }else
           {
            let dados = { 
                CodCntr: this.props.container.CodCntr,
                armador: this.props.container.armador,
                importador: this.props.container.importador,
                PreviaImportacaoDepot: this.props.container.PreviaImportacaoDepot,
                ArmId: this.props.container.ArmId,
                CodIso:  this.props.container.CodIso
           }
           _.set(this.props.agendamento.dadosAgendamento, `Containeres[${this.props.index}]`, dados);
        }


        }
    }


    render() {
        
        console.log(this.props.container)
        return (
           
            <Col className={this.props.isEscondido ? "card-detalhes escondido" : "card-detalhes"} md={9}>
                <div className="titulo card-branco">
                    <h2 className="mt-3">{_.get(this.props.container, "CodCntr") ? _.get(this.props.container, "CodCntr").toUpperCase() : ""}</h2>
                </div>
                <div className="area-form detalhes card-branco">
                    <Row>

                        <Label>{this.props.container.existsOnApi === false ? "Container não encontrado":""}</Label>
                        { (this.props.container.armador != null && this.props.container.armador != undefined) ? <FormInput titulo="Armador" xs={12} sm={12} md={7}
                            value={this.props.container.armador}
                            bloqueado={true}
                            /> : null }  
                        {this.props.container.existsOnApi && <FormSelect titulo="Importador/Exportador"  xs={12} sm={12} md={4} className="mt-lg-1 mt-xl-1"
                                objeto={this.props.container}
                                dado={`importador`}
                                itens={this.controller.clientes}
                                bloqueado={this.props.agendamento.isEditar}
                                itensValor="CampoValue" itensLabel="CampoDescricao"
                                onChange={(event) => { this.handleCampoChange(event, 'importador', 'importador', (event != null ? event.label : null)) }}
                                isSearchable={true}
                                onInputChange={(event) => this.buscaImportador(event)} 
                                />}
                        { (this.props.container.peso != null && this.props.container.peso != undefined) ? <FormInput titulo="Peso" xs={12} sm={12} md={7}
                            value={this.props.container.peso}
                            bloqueado={true}
                            /> : null }  
                        
                        { (this.props.container.peso != null && this.props.container.peso != undefined) ? <FormInput titulo="Hora do Evento" xs={12} sm={12} md={7}
                            value={this.props.container.horaEvento}
                            bloqueado={true}
                            /> : null }  
                        
                        { (this.props.container.local != null && this.props.container.local != undefined) ? <FormInput titulo="Local" xs={12} sm={12} md={7}
                            value={this.props.container.local}
                            bloqueado={true}
                            /> : null }  

                        { (this.props.container.terminal != null && this.props.container.terminal != undefined) ? <FormInput titulo="Terminal" xs={12} sm={12} md={7}
                            value={this.props.container.terminal}
                            bloqueado={true}
                            /> : null } 
                        
                        { (this.props.container.status != null && this.props.container.status != undefined) ? <FormInput titulo="Status do Conteiner" xs={12} sm={12} md={7}
                            value={this.props.container.status}
                            bloqueado={true}
                            /> : null } 
                        
                        { (this.props.container.tipo != null && this.props.container.tipo != undefined) ? <FormInput titulo="Tipo do Conteiner" xs={12} sm={12} md={7}
                            value={this.props.container.tipo}
                            bloqueado={true}
                            /> : null } 
                        { (this.props.container.navioViagem != null && this.props.container.navioViagem != undefined) ? <FormInput titulo="Navio Viagem" xs={12} sm={12} md={7}
                            value={this.props.container.navioViagem}
                            bloqueado={true}
                            /> : null } 
                    </Row>


            
                </div>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/importacao-entrada-depot/components/CardContainerFilho.js